<template>
    <div>
        <b-button class="m-1" @click="modalShow = true" variant="primary"> 
            Crear tipo <b-icon icon="archive" font-scale="1"></b-icon>
        </b-button>
        <BaseModal ref="modal" v-model="modalShow" size="sm">
            <form @submit.prevent="submitType">
                <div class="mb-3">
                    <label for="tipoDenuncia" class="form-label">Tipo de denuncia</label>
                    <input type="text" class="form-control" id="tipoDenuncia" v-model="newDenunciationType">
                </div>
                <button type="submit" class="btn btn-primary" :disabled="!newDenunciationType || creatingDenunciationType">
                    <b-spinner small v-if="creatingDenunciationType" class="mr-1"></b-spinner>
                    Agregar
                </button>
            </form>
        </BaseModal>
    </div>
</template>

<script>
import { EventNames } from '@/plugins/enums';
import { mapActions } from 'vuex';
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: 'KarinTypeForm',

    components: {
        BaseModal
    },

    data() {
        return {
            modalShow: false,
            creatingDenunciationType: false,
            newDenunciationType: null,
        }
    },

    methods: {
        ...mapActions(['createKarinDenunciationType']),

        async submitType() {
            this.creatingDenunciationType = true;
            let result = await this.createKarinDenunciationType({ name: this.newDenunciationType });

            if (result.isError) {
                this.$refs.modal.showAlert(result.message, 'danger');
                this.creatingDenunciationType = false;
            }

            this.creatingDenunciationType = false
            this.newDenunciationType = null;
            this.$refs.modal.showAlert('Tipo creado correctamente', 'success');
            this.$eventBus.$emit(EventNames.KarinCreatedType)
            
        }
    }
}
</script>
